import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'ConfigParameter/All', method: 'GET', body: null, token: token })
}
